import { render, staticRenderFns } from "./notesTabWrapper.vue?vue&type=template&id=c7526514&"
import script from "./notesTabWrapper.vue?vue&type=script&lang=js&"
export * from "./notesTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./notesTabWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports